const setEditMode = (state, payload) => {
  state.isPPTEditMode = payload
}
const setActiveViewMode = (state, payload) => {
  state.addinPPTActiveView = payload
}
const setPptSlideLostFocus = (state, payload) => {
  state.pptSlideLostFocus = payload
}
export default {
  setEditMode,
  setActiveViewMode,
  setPptSlideLostFocus,
}
